import type { ComponentProps } from "react";
import { styled } from "styled-system/jsx";
import { textarea } from "styled-system/recipes";
import TextareaAutosize from "react-textarea-autosize";

export const Textarea = styled(TextareaAutosize, textarea);
export interface TextareaProps extends ComponentProps<typeof Textarea> {}
